import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Panel, FormLayout, Input, TextArea, DatePicker, AutosaveStatus} from 'components';
import {ModalButtons} from 'components/modals';

const GoalForm = observer(({goal, errors, sharedWith, onSave, onCancel, uiState}) => {
  return (
    <div>
      <Panel.Header title={goal.titleView} description={t("goals.DESCRIPTION")} />
      <FormLayout>
        <Input
          value={goal.title}
          onChange={e => uiState.updateGoal({title: e.target.value})}
          label='goals.Title'
          placeholder='goals.e.g. Reach monthly demonstration target'
          errorMessage={errors.title}
        />
        <TextArea
          value={goal.description}
          onChange={e => uiState.updateGoal({description: e.target.value})}
          label='goals.Description'
          placeholder='goals.Schedule 50 demonstrations every month for the entire quarter.'
          errorMessage={errors.description}
          minRows={2}
        />
        <FormLayout.Group>
          <DatePicker
            value={goal.startDate}
            onChange={date => uiState.updateGoal({startDate: date})}
            label='goals.Start Date'
            errorMessage={errors.startDate}
          />
          <DatePicker
            value={goal.endDate}
            onChange={date => uiState.updateGoal({endDate: date})}
            label='goals.End Date'
            errorMessage={errors.endDate}
          />
        </FormLayout.Group>
        {sharedWith && <div className='jumbo'>
          <i className='material-icons h3 align-middle waterloo mr1'>{'visibility'}</i>
          {sharedWith}
        </div>}
      </FormLayout>
      <ModalButtons
        onSave={() => onSave()}
        onCancel={() => onCancel()}
      >
        <AutosaveStatus autosaver={goal.autosaver} className='mr2' />
      </ModalButtons>
    </div>
  );
});

export default GoalForm;
